













import { Component, Vue, Watch, Ref, Mixins } from 'vue-property-decorator'
import { State, Getter, Action } from 'vuex-class'
import JobDetailsHeader from '@/features/job/components/JobDeatailsHeader.vue'
import JobDetailsStatusBar from '@/features/job/components/JobDetailsStatusBar.vue'
import JobDetailsList from '@/features/job/components/JobDetailsList.vue'
import RemoveJobDialog from '@/features/job/components/RemoveJobDialog.vue'
import JobDetailsBottomBar from '@/features/job/components/JobDetailsBottomBar.vue'
import { IProcessingErrors, IJob } from '@/features/job/store'

import { FETCH_CURRENT_JOB, FETCH_JOB_BY_ID_ACTION, CLEAR_JOB, FILL_SELECTED_JOB, CLEAR_SELECTED_JOB } from '@/system/store/action-types'
import { IActionType, IStore } from '@/system/store'
import { JOB_STATUSES } from '@/constants'
import HandleLoaders from '@/shared/HandleLoaders.component.vue'

@Component({
  components: {
    JobDetailsHeader,
    JobDetailsStatusBar,
    JobDetailsList,
    RemoveJobDialog,
    JobDetailsBottomBar
  }
})
export default class JobDetailsView extends Mixins(HandleLoaders) {
  private jobStatuses = JOB_STATUSES

  @State(({ job }: IStore) => job.job) job!: IJob
  @State(({ job }: IStore) => job.selectedJob) selectedJob!: IJob
  @Ref()
  readonly modal!: RemoveJobDialog
  @Action(FETCH_JOB_BY_ID_ACTION)
  fetchJobId!: IActionType
  @Action(CLEAR_JOB)
  clearJob!: IActionType
  @Action(CLEAR_SELECTED_JOB)
  clearSelectedJob!: IActionType
  @Action(FILL_SELECTED_JOB)
  setSelectedJob!: IActionType

  @Watch('job')
  jobLoaded () {
    if (!this.selectedJob) this.setSelectedJob({ ...this.job })
    this.hideLoader()
  }

  protected created (): void {
    this.showDualRingSpinner()
    this.fetchJobId(this.$route.params.uuid)
  }

  protected destroyed (): void {
    this.clearJob()
    this.clearSelectedJob()
  }

  public showDialog (): void {
    this.modal.openDialog()
  }

  private getStatus (): string {
    if (!this.selectedJob) return this.jobStatuses.PENDING
    return this.selectedJob.status
  }

  private hasErrorsList (): boolean {
    const { status, meta: { processingErrors = [] } } = this.selectedJob
    const { FAILED } = this.jobStatuses

    return Boolean(processingErrors.length && status !== FAILED)
  }

  private isFailed (): boolean {
    const { status } = this.selectedJob
    const { FAILED } = this.jobStatuses

    return status !== FAILED
  }

  public downloadOriginalFile (): void {
    if (!this.selectedJob?.meta?.originalFileUrl) {
      console.error('Original file URL is missing')
      return
    }

    const url = this.selectedJob.meta.originalFileUrl
    const fileName = this.selectedJob.meta.originalName || 'download'

    try {
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('Error downloading file:', error)
      alert(`Error downloading file: ${error}`)
    }
  }
}
